import { motion } from "framer-motion";
import { staggerContainer } from "../utils/motion";
import { useSelector } from "react-redux";

const StarWrapper = (Component, idName) =>

  function HOC() {
   
const lang = useSelector((state) => state.cart.lang);

 
    return (
      <motion.section
        variants={staggerContainer()}
        initial='hidden'
        dir={lang=== 'en' ?  "rtl" : "ltr" } 
        whileInView='show'
        viewport={{ once:true, amount: 0.25 }}
        className={`   relative z-0`}
      >
        <span className='hash-span' id={idName}>
          &nbsp;
        </span>

        <Component />
      </motion.section>
    );
  };

export default StarWrapper;
